import "./index.scss";
import { useEffect, useState } from "react";

import Chart from "chart.js/auto";
import "chartjs-adapter-luxon";
import ChartStreaming from "chartjs-plugin-streaming";
import zoomPlugin from 'chartjs-plugin-zoom';


import { Line } from "react-chartjs-2";
import API from "../../api";
import {
  Alert,
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Snackbar,
  Typography,
} from "@mui/material";
import AddDevice from "../../components/modals/addDevice";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import DownloadIcon from "@mui/icons-material/Download";
import Settings from "../../components/modals/chartSettings";
import speedMetersDefault from "../../speedMetersDeafult.json";
import { downloadAsExcel } from "../../utils";
import SpeedOMeter from "../../components/speedOmeter";

Chart.register(zoomPlugin, ChartStreaming);

const barkAudio = "/sound/single-dog-bark.wav";
const notBarkAudio = "/sound/coltonmanz__alarm.wav";
const nullAudio = "data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
const sounds = {
  bark: new Audio(nullAudio),
  notBark: new Audio(nullAudio),
};
// sounds.bark.autoplay = true;
// sounds.notBark.autoplay = true;
const unlockAudio = () => {
  sounds.bark.play();
  sounds.notBark.play();
  setTimeout(()=>{
    sounds.bark.src=barkAudio;
    sounds.notBark.src=notBarkAudio;
  },1000);
};
document.body.addEventListener('touchend',unlockAudio(),{capture:true, once:true})
document.body.addEventListener('click',unlockAudio(),{capture:true, once:true})

// sounds.bark.autoPlay = true
// sounds.notBark.autoPlay = true

function Main(props) {
  const maxChartAlertTime = 10; //n times alarm
  let lock=false //prevents updating charts to be able to remove data;
  const [callInterval, setCallInterval] = useState(1000);
  const [addDeviceModalOpen, setAddDeviceModalOpen] = useState(false);
  const [charts, setCharts] = useState(
      JSON.parse(localStorage.getItem("charts") || "[]")
  );
  const [chartsData, setChartsData] = useState([[]]);
  const [apiCallCounter, setApiCallCounter] = useState(0);
  const [displaySettings, setDisplaySettings] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [alertLength, setalertLength] = useState(0);

  const [data, setData] = useState([]);
  const options = {
    animation: false,
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      point: { radius: 0 },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 12,
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        bodyFont: {
          size: 16,
        },
      },
      // zoom: {
      //   pan: {
      //     enabled: true,
      //     mode: 'y'
      //   },
      //   zoom: {
      //     pinch: {
      //       enabled: true
      //     },
      //     wheel: {
      //       enabled: true
      //     },
      //     mode: 'y'
      //   },
      // },
      // Change options for ALL axes of THIS CHART
      streaming: {
        duration: 5 * 60 * 1000,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Time",
        },
        type: "realtime",
        // Change options only for THIS AXIS
        realtime: {
          duration: 5 * 60 * 1000,
          refresh: 1000,
          ttl: 30 * 60 * 1000,
          frameRate: localStorage.getItem("powerSaver") === "true" ? 1 : 20,
          delay: 2500,
        },
      },
      y: {
        title: {
          display: true,
          text: "Value",
          ticks: {
            min:0
          }
        },
      },
    },
    interaction: {
      intersect: false,
    },
    transitions: {
      zoom: {
        animation: {
          duration: 1000,
          easing: 'easeOutCubic'
        }
      }
    }
  };

  const modifyChart = (data) => {
    if (data.delete) {
      removeChart(data.index);
    } else {
      lock = true;
      const newCharts = [...charts];
      newCharts[data.index].deadBand = data.deadband;
      newCharts[data.index].speedMeters = data.speedMeters;
      // the data we use no backend for
      newCharts[data.index].setPoint = data.setPoint;
      newCharts[data.index].secSetPoint = data.secSetPoint;
      setCharts(newCharts);
      localStorage.setItem("charts", JSON.stringify(newCharts));
      setRefresh(true);
      setTimeout(() => {
        setRefresh(false);
        lock = false;
      }, 1000);
    }
    setDisplaySettings({ open: false });
  };
  const addChart = (uuid) => {
    if (!uuid) {
      setAddDeviceModalOpen(false);
      setTimeout(() => {
        setAddDeviceModalOpen(true);
      }, 0);
      return;
    }
    const newCharts = [...charts];
    newCharts.push({
      uuid: uuid,
      deadBand: 10,
      speedMeters: [...speedMetersDefault],
    });
    setCharts(newCharts);
    localStorage.setItem("charts", JSON.stringify(newCharts));
    const newChartsData = [...chartsData];
    newChartsData.push([]);
    setChartsData(newChartsData);
    setTimeout(() => {
      setApiCallCounter((prevState) => prevState + 1);
    }, 0);
  };
  const removeChart = async(index) => {
    lock = true;
    const newCharts = [...charts];
    newCharts.splice(index, 1);
    setCharts(newCharts);
    const newChartsData = [...newCharts];
    newChartsData.splice(index, 1);
    setChartsData(newChartsData);
    localStorage.setItem("charts", JSON.stringify(newCharts));
    setTimeout(()=>{
      lock = false;
    },3000);
  };

  useEffect(async () => {
    if (charts.length === 0 && addDeviceModalOpen === false) {
      return setAddDeviceModalOpen(true);
    }
    const newChartsData = [...chartsData];
    const newData = [...data];
    for (let i = 0; i < charts.length; i++) {
      let alert = false;
      let reason = '';
      try {
        let resp = await API.get(
            `https://${charts[i].uuid}.balena-devices.com/sensorData`
        );
        resp = resp.data;
        for(let key in resp){
          if(resp[key]<0) resp[key]=0;
        }
        resp.volume = (resp.volume||0)/1000;
        //ignore backend data
        resp.setPoint = charts[i].setPoint;
        resp.secSetPoint = charts[i].secSetPoint;
        if (newChartsData[i] === undefined) {
          newChartsData.push([]);
        }
        //evaluate bark status
        // console.log(resp.setPoint , '<=' ,resp.avgFlow)
        let deadband_graph_value =
            resp.setPoint - resp.setPoint * (charts[i].deadBand / 100);
        let deadband_graph_value_max =
            resp.setPoint + resp.setPoint * (charts[i].deadBand / 100);


        if (resp.secSetPoint !== 0 && resp.secVal >= resp.secSetPoint * 0.9) {
          // [TODO] add if done for x seconds then trigger
          console.warn("Transition to pressure mode");
          alert = true;
          reason = 'Pressure is above 90% of PSI Set Point!';
        }else if (resp.avgFlow < deadband_graph_value) {
          //this spot if very important!
          // if the code reaches here this is what the whole app is built around
          // it means that the flow rate has dropped unexpectly and a action_statemachine should be taken
          reason = 'Average Flow is less than min deadband graph value!';
          alert = true;

        } else if (resp.avgFlow > deadband_graph_value_max) {
          console.log("api_res.avgFlow  >  deadband_graph_value");
          reason = 'Average Flow is above max deadband value!';
          // big spot to flash red
          alert = true;
        } else {
          // if the code reaches here this means the pump is running normally everythings A OK!
          //reset background to normal color
          reason = 'all good!';
          alert = false;
        }

        newChartsData[i].push({ ...resp, date: new Date() });
      } catch (e) {
        console.error(e);
      }
      const newCharts = [...charts];
      if (alert) {
        newCharts[i].alertCount = newCharts[i].alertCount
            ? newCharts[i].alertCount + 1
            : 1;
        if (newCharts[i]?.alertCount < maxChartAlertTime) {
          localStorage.getItem("noBark") !== "true"
              ? sounds.bark.play()
              : sounds.notBark.play();
          setTimeout(() => {
            localStorage.getItem("noBark") !== "true"
                ? sounds.bark.play()
                : sounds.notBark.play();
          }, 1500);
        }
      } else {
        newCharts[i].alertCount = 0;
      }
      newCharts[i].alert = alert;
      newCharts[i].reason = reason;
      if(!lock) setCharts(newCharts);

      // if(chartsData[i]?.length % 60 === 2 || chartsData[i]?.length % 60 === 1) {
      newData[i] = {
        datasets: [
          {
            label: "Average Flow",
            cubicInterpolationMode: "monotone",
            backgroundColor: "rgb(0, 121, 0)",
            borderColor: "rgb(0, 121, 0)",
            data: chartsData[i]?.map((item) => ({
              x: item.date,
              y: item.avgFlow,
            })),
          },
          {
            label: "Instant Flow",
            cubicInterpolationMode: "monotone",
            backgroundColor: "rgb(0, 0, 255)",
            borderColor: "rgb(0, 0, 255)",
            data: chartsData[i]?.map((item) => ({
              x: item.date,
              y: item.instantFlow,
            })),
          },
          {
            label: "Setpoint Flow",
            cubicInterpolationMode: "monotone",
            backgroundColor: "rgb(255, 127, 0)",
            borderColor: "rgb(255, 127, 0)",
            data: chartsData[i]?.map((item) => ({
              x: item.date,
              y: item.setPoint,
            })),
          },
          {
            label: "Total Volume(Kg)",
            cubicInterpolationMode: "monotone",
            backgroundColor: "rgb(161,126,0)",
            borderColor: "rgb(161,126,0)",
            data: chartsData[i]?.map((item) => ({
              x: item.date,
              y: item.volume,
            })),
          },
          {
            label: "Pressure Setpoint",
            cubicInterpolationMode: "monotone",
            backgroundColor: "rgb(255,0,0)",
            borderColor: "rgb(255,0,0)",
            data: chartsData[i]?.map((item) => ({
              x: item.date,
              y: item.secSetPoint,
            })),
          },
          {
            label: "Pressure",
            cubicInterpolationMode: "monotone",
            backgroundColor: "rgb(186,0,255)",
            borderColor: "rgb(186,0,255)",
            data: chartsData[i]?.map((item) => ({
              x: item.date,
              y: item.secVal,
            })),
          },

          {
            label: "Temperature",
            cubicInterpolationMode: "monotone",
            backgroundColor: "rgb(64,32,0)",
            borderColor: "rgb(64,32,0)",
            data: chartsData[i]?.map((item) => ({
              x: item.date,
              y: item.tempC,
            })),
          },
        ],
      };
      // }
      setTimeout(() => {
        // charts[2].alert = Math.random() > 0.5 ? true : false;
        // setCharts(charts);
        setApiCallCounter(apiCallCounter + 1);
      }, callInterval);
    }
    if(!lock) setData(newData);
    if(!lock) setChartsData(newChartsData);
  }, [apiCallCounter]);

  return (
      <Grid justifyContent="center" alignItems="center" container spacing={1}>
        {charts &&
        charts.map((item, index) => (
            <Snackbar
                key={`AAREA-${index}`}
                open={item?.alert}
                autoHideDuration={5000}
            >
              <Alert severity="error" sx={{ width: "100%" }}>
                PID#{index + 1} needs attention {item?.reason}
              </Alert>
            </Snackbar>
        ))}
        {charts.map((chart, index) => (
            <Grid
                key={chart.uuid + index}
                item
                xs={12}
                sm={12}
                md={12}
                lg={charts.length === 1 ? 12 : 6}
                xl={charts.length === 1 ? 12 : 6}
            >
              <Card
                  sx={{
                    backgroundColor: chart.alert ? "#ff000066" : "ffffffff",
                    transition: "all 0.3s",
                  }}
              >
                <CardHeader
                    action={
                      <>
                        <IconButton
                            onClick={() => {
                              setDisplaySettings({
                                open: true,
                                index: index,
                                deadband: chart.deadBand,
                                speedMeters: chart.speedMeters,
                                setPoint: chart?.setPoint,
                                secSetPoint: chart?.secSetPoint,
                              });
                            }}
                            aria-label="settings"
                        >
                          <SettingsIcon />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                              downloadAsExcel({
                                filename: `PID#${index + 1}-${Date.now()}`,
                                chart: data[index],
                              });
                            }}
                            aria-label="settings"
                        >
                          <DownloadIcon />
                        </IconButton>
                      </>
                    }
                    title={`PID#${index + 1}`}
                    subheader={chart.uuid}
                    style={{ paddingBottom: "0" }}
                />
                <CardContent style={{ padding: "0" }}>
                  <Grid
                      justifyContent="center"
                      direction="row"
                      alignItems="center"
                      container
                      spacing={2}
                  >
                    {chart?.speedMeters?.map((item2, index2) => {
                      if (item2.display)
                        return (
                            <Grid
                                key={`CHARTMETER-${index2}-${item2.label}`}
                                item
                                xs={4}
                                sm={3}
                                md={2}
                                lg={charts.length === 1 ? 1.5 : 2}
                                xl={charts.length === 1 ? 1.5 : 2}
                            >
                              <div style={{ transition: "all 1s" }}>
                                <SpeedOMeter
                                    label={item2.label}
                                    value={
                                      chartsData &&
                                      chartsData[index] &&
                                      chartsData[index][chartsData[index].length - 1]?.[
                                          item2.key
                                          ]
                                    }
                                    min={item2.min}
                                    max={item2.max}
                                    width={85}
                                />
                                {/*<ReactSpeedometer*/}
                                {/*  forceRender={refresh}*/}
                                {/*  // fluidWidth={true}*/}
                                {/*  width={150}*/}
                                {/*  height={120}*/}
                                {/*  labelFontSize="12px"*/}
                                {/*  valueTextFontSize="12px"*/}
                                {/*  needleHeightRatio={0.6}*/}
                                {/*  maxValue={item2.max}*/}
                                {/*  minValue={item2.min}*/}
                                {/*  segments={*/}
                                {/*    item2.segments*/}
                                {/*  }*/}
                                {/*  segmentColors={*/}
                                {/*    item2.segmentColors*/}
                                {/*  }*/}
                                {/*  startColor={*/}
                                {/*    item2.startColor*/}
                                {/*  }*/}
                                {/*  endColor={*/}
                                {/*    item2.endColor*/}
                                {/*  }*/}
                                {/*  value={*/}
                                {/*    chartsData &&*/}
                                {/*    chartsData[index] &&*/}
                                {/*    chartsData[index][chartsData[index].length - 1]?.[*/}
                                {/*      item2.key*/}
                                {/*    ]*/}
                                {/*  }*/}
                                {/*  currentValueText={`${item2.label}: ${chartsData && chartsData[index] && chartsData[index][chartsData[index].length - 1]?.[item2.key] || 0}`}*/}
                                {/*  needleColor="white"*/}
                                {/*/>*/}
                              </div>
                            </Grid>
                        );
                    })}
                  </Grid>
                </CardContent>
                <CardContent>
                  <div
                      style={{
                        // width: 100/charts.length+'vh',
                        minWidth: "100%",
                        height: charts.length === 1 ? "50vh" : "50vh",
                      }}
                  >
                    {data[index] ? (
                        <Line options={options} data={data[index]} />
                    ) : (
                        <Typography variant="h6" gutterBottom component="div">
                          Generating charts from data...
                        </Typography>
                    )}
                  </div>
                </CardContent>
              </Card>
              <div style={{ minHeight: "50px" }} />
            </Grid>
        ))}
        <AddDevice
            callback={(e) => {
              addChart(e);
            }}
            open={addDeviceModalOpen}
        />
        <Settings
            open={displaySettings?.open}
            deadband={displaySettings?.deadband}
            speedMeters={displaySettings?.speedMeters}
            index={displaySettings?.index}
            setPoint={displaySettings?.setPoint}
            secSetPoint={displaySettings?.secSetPoint}
            onClose={(e) => {
              modifyChart(e);
            }}
        />
      </Grid>
  );
}

export default Main;
